export default __webpack_public_path__ + "static/media/icon_2.0dc727e6.png";